import styles from "../../assets/styles/Feedback/Feedback.module.scss";
import React, { useMemo, useState } from "react";
import {
  AppPage,
  MimaButton,
  MimaNewFilter,
  MimaTable,
} from "../../components";
import { AnimatePresence } from "framer-motion";
import moment from "moment";
import { ViewMoreFeedbackContainer } from "../../containers";
import constant from "../../utils/constant";

const FeedbackRes = ({
  closeModal,
  filterHandler,
  setFeedbackModal,
  feedbackModal,
  isLoading,
  feedbackData,
  isFetching,
  limit,
  onLimitChange,
  currentPage,
  setCurrentPage,
  setSearchQuery,
}) => {
  const [showFilter, setShowFilter] = useState(false);
  const [data, setData] = useState({});

  const filterByData = [{ value: "Date", key: "createdAt" }];

  const tableData = useMemo(() => {
    if (feedbackData?.status === constant.Success) {
      return feedbackData?.data?.reviews || [];
    }
    return [];
  }, [feedbackData]);

  const tableColumns = [
    {
      Header: "Date And Time",
      accessor: "createdAt",
      Cell: ({ cell }) => {
        const date = cell.row.original?.createdAt;
        return <span>{moment(date).format("DD/MM/YYYY HH:mm a")}</span>;
      },
    },
    {
      Header: "Business Name",
      accessor: "tradingName",
      Cell: ({ cell }) => {
        const businessName = cell.row.original.business.tradingName;
        return <span>{businessName}</span>;
      },
    },
    {
      Header: "Action Performed",
      accessor: "key",
      Cell: ({ cell }) => {
        const actionPerformed = cell.row.original.reviewId.key;
        return <span>{actionPerformed}</span>;
      },
    },
    {
      Header: "Response",
      Cell: ({ cell }) => {
        const rating = cell.row.original.rating;
        const response =
          rating === 1
            ? "Terrible"
            : rating === 2
              ? "Bad"
              : rating === 3
                ? "Neutral"
                : rating === 4
                  ? "Good"
                  : "Amazing";
        return <span>{response}</span>;
      },
    },
    {
      Header: "Suggestion",
      accessor: "review",
    },

    {
      Header: "Status",
      accessor: "status",
      Cell: ({ cell }) => {
        const status = cell.value;
        const statusClass = `status ${
          status === "CLOSED" ? "status__green" : "status__red"
        }`;
        return <span className={statusClass}>{status}</span>;
      },
    },
    {
      Header: "Actions",
      Cell: ({ cell }) => {
        const item = cell.row.original;
        return (
          <span
            className="tableAction__text"
            onClick={() => {
              setData(item);
              setFeedbackModal(true);
            }}
          >
            View More
          </span>
        );
      },
    },
  ];

  return (
    <AppPage pageTitle="Feedback Response">
      <>
        <MimaButton
          title={showFilter ? "Close Filter" : "Filter"}
          onClick={() => setShowFilter(!showFilter)}
        />

        <MimaNewFilter
          showFilter={showFilter}
          setShowFilter={setShowFilter}
          filterByData={filterByData}
          filterHandler={filterHandler}
        />

        <MimaTable
          tableData={tableData}
          tableColumns={tableColumns}
          searchPlaceholder="Search Feedback"
          searchVariant="wide"
          totalItems={feedbackData?.data?.totalCounts}
          onLimitChange={onLimitChange}
          isLoading={isLoading}
          isFetching={isFetching}
          limit={limit}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          setSearchQuery={setSearchQuery}
        />

        {feedbackModal && (
          <div className="modal">
            <AnimatePresence>
              {feedbackModal && (
                <ViewMoreFeedbackContainer
                  data={data}
                  closeModal={closeModal}
                />
              )}
            </AnimatePresence>
          </div>
        )}
      </>
    </AppPage>
  );
};
export default FeedbackRes;
